import { Task } from './columns-tasks';
import type { MatterMember } from '@/types/base';
import type { DeadlineTagVocabularyItem } from '@/hooks/useTagVocabulary';
import type { DeadlineTagChanges } from '@/lib/deadlines/tags';
import { TaskFormDialog } from './task-form-dialog';

interface EditTaskDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onEditTask: (taskId: string, updates: Partial<Task>) => void;
  task: Task | null;
  members?: MatterMember[];
  availableTasks?: Task[];
  /** Controlled tag vocabulary. Omit (with onSaveTags) to hide the Tags field. */
  tagVocabulary?: DeadlineTagVocabularyItem[];
  /** Persists the staged tag edits on save. Omit to hide the Tags field. */
  onSaveTags?: (syntheticId: string, changes: DeadlineTagChanges) => void | Promise<void>;
}

export const EditTaskDialog = ({
  isOpen,
  onClose,
  onEditTask,
  task,
  members = [],
  availableTasks = [],
  tagVocabulary,
  onSaveTags,
}: EditTaskDialogProps) => {
  return (
    <TaskFormDialog
      mode="edit"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onEditTask}
      task={task}
      members={members}
      availableTasks={availableTasks}
      tagVocabulary={tagVocabulary}
      onSaveTags={onSaveTags}
    />
  );
};
